// Advisor pack templates (moved from the static Data Studio into firm admin → Templates).

export type PackBlock = { block_key: string; label: string; stable_table_name: string }
export type PackManifest = {
  pack_key: string
  version: number
  name: string
  description: string
  host_compatibility: string[]
  blocks: PackBlock[]
  [key: string]: unknown
}

export function advisorDraftManifest(sourceManifest: PackManifest | null | undefined, fields: { packKey?: string; name?: string; description?: string }): PackManifest {
  if (!sourceManifest || typeof sourceManifest !== 'object') throw new Error('Choose a source pack to begin.')
  const packKey = fields.packKey?.trim()
  const name = fields.name?.trim()
  const description = fields.description?.trim() || ''
  if (!packKey || !name) throw new Error('Enter a stable pack key and name.')
  return { ...structuredClone(sourceManifest), pack_key: packKey, version: 1, name, description }
}

export function packPreviewRows(manifest: PackManifest | null | undefined): Array<[string, string]> {
  if (!manifest) return []
  return [
    ['Stable key', manifest.pack_key],
    ['Version', String(manifest.version)],
    ['Hosts', manifest.host_compatibility.join(', ')],
    ['Governed tables', String(manifest.blocks.length)],
    ['Tables', manifest.blocks.map((block) => block.stable_table_name).join(', ')],
  ]
}

export function installationDriftLabel(item: { drift?: { status?: string }; installation?: { pack_version?: number } } | null | undefined): string {
  const status = item?.drift?.status || 'unknown'
  const version = item?.installation?.pack_version
  if (status === 'drifted') return `Update available · installed v${version}`
  if (status === 'current') return `Current · v${version}`
  if (status === 'retired') return `Template retired · installed v${version}`
  return `Status unavailable · installed v${version ?? '?'}`
}
